@if (instrument) {
  <div
    class="dropdown"
    ngClass="{{ toggled ? 'dropdown--toggled' : '' }}"
    data-cy="dropdown-instrument-list-item"
    >
    <div
      class="header"
      (click)="toggle()"
      [ngStyle]="{ color: instrumentCategoryColors[instrument.instrument.instrumentCategory] }"
      [ngClass]="{ 'header--detail': instrumentRatios }"
      data-cy="dropdown-toggle-header"
      (keydown.space)="toggle()"
      (keydown.enter)="toggle()"
      tabindex="0"
      >
      <div class="name-icon-container">
        <svg-icon
          src="assets/icons/chevron-down.svg"
          [svgStyle]="{ 'width.px':18, 'transform': toggled ? 'rotate(180deg)' : '' }"
          [ngStyle]="{ fill: instrumentCategoryColors[instrument.instrument.instrumentCategory] }"
        ></svg-icon>
        <div class="name " [ngClass]="{ 'name--cash': instrument.instrument.cash }">
          @if (!instrument.instrument.cash) {
            {{ instrument.instrument.humanName }}
          } @else {
            {{ 'global.cash' | translate }} ({{ instrument.instrument.currencyCode }})
          }
        </div>
      </div>
      @if (instrumentRatios) {
        <div class="value value--desktop value--text-center" data-cy="amount-ratio-header">
          {{ instrumentRatios.weight * 100 | number:'1.0-2' }} % / {{ instrumentRatios.amountRatio * 100 | number:'1.0-2' }} %
        </div>
        <div class="value value--desktop" data-cy="amount-header">
          {{ instrumentRatios.amount | price:'CZK' }}
        </div>
      } @else if (!instrument.instrument.cash) {
        <div class="value" data-cy="fallback-value-header">
          @if (instrument.instrument.yield1Y) {
            {{ instrument.instrument.yield1Y * 100 | number:'1.0-2' }} %
          } @else {
            {{ 'global.error.unknownYield' | translate }}
          }
        </div>
      }
    </div>
    <div class="content">
      @if (instrumentRatios) {
        <div class="phone-values-container">
          <div class="headers" data-cy="detail-ratios-headers">
            <div class="heading heading--capitalize-all" style="padding-right: 30px;">
              {{ 'newPortfolio.goal' | translate }}
            </div>
            <div class="heading">
              {{ 'newPortfolio.value' | translate }}
            </div>
          </div>
          <div class="values">
            <div class="phone-value" data-cy="amount-ratio-header-phone">
              {{ instrumentRatios.weight * 100 | number:'1.0-2' }} % / {{ instrumentRatios.amountRatio * 100 | number:'1.0-2' }} %
            </div>
            <div class="phone-value" data-cy="amount-header-phone">
              {{ instrumentRatios.amount | price:'CZK' }}
            </div>
          </div>
        </div>
      }
      @if (instrument.instrument.name && !instrument.instrument.cash) {
        <div class="pb-2">
          {{ instrument.instrument.name }}
        </div>
      }
      @if (instrument.instrument.description && instrument.instrument.description.length > 0) {
        <p [innerHTML]="instrument.instrument.description | htmlFormat">
        </p>
      } @else if (!instrument.instrument.cash) {
        <div class="no-description">
          {{ 'global.error.instrumentWithoutDescription' | translate }}
        </div>
      } @else {
        {{ 'global.cashDescription' | translate }}
      }
      @if (instrument.instrument.web) {
        <a
          class="description-web"
          href="{{ instrument.instrument.web }}"
          target="_blank"
          >
          {{ 'dropdown.productsWeb' | translate }}
        </a>
      }
    </div>
  </div>
}
